module.exports = __webpack_public_path__ + "img/bishophall-v-474x632.67446f38.jpg";